import { guideIconHtml } from "@scalar-org/guide-icons";
import { toVueComponent } from "@scalar-org/vue-render";
import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
import { CalloutType } from "./attributes.js";
var InfoIconType = /* @__PURE__ */ ((InfoIconType2) => {
  InfoIconType2["Neutral"] = "neutral";
  InfoIconType2["Success"] = "success";
  InfoIconType2["Danger"] = "danger";
  InfoIconType2["Warning"] = "warning";
  InfoIconType2["Info"] = "info";
  return InfoIconType2;
})(InfoIconType || {});
const calloutIconKey = {
  [CalloutType.Neutral]: "phosphor/regular/info",
  [CalloutType.Success]: "phosphor/regular/check-circle",
  [CalloutType.Danger]: "phosphor/regular/warning-circle",
  [CalloutType.Warning]: "phosphor/regular/warning",
  [CalloutType.Info]: "phosphor/regular/info"
};
function calloutIconNameFromType(props) {
  return props.type ? calloutIconKey[props.type] : calloutIconKey[CalloutType.Neutral];
}
const calloutHtmlBase = (props, iconHtml) => {
  const type = props.type ?? CalloutType.Info;
  const classNames = [
    "callout",
    EditorClasses.Callout,
    `callout__${type}`
  ].filter(Boolean);
  return html`
    <div class="${classNames.join(" ")}">
      <div class="callout-content">
        <div data-scalar-name="callout-icon" class="callout-content__icon">
          ${iconHtml}
        </div>
        <div class="callout-content__text">
          <ssg-children></ssg-children>
        </div>
      </div>
    </div>
  `;
};
const guideCalloutHtml = async (props) => {
  const iconHtml = await guideIconHtml({
    src: props.icon || calloutIconNameFromType({ type: props.type || CalloutType.Info })
  });
  return calloutHtmlBase(props, iconHtml);
};
const ScalarCalloutVue = toVueComponent(
  (props) => calloutHtmlBase(props, '<ssg-children name="icon"></ssg-children>'),
  {
    type: String,
    icon: String,
    isEditable: Boolean
  }
);
export {
  InfoIconType,
  ScalarCalloutVue,
  calloutIconNameFromType,
  guideCalloutHtml
};
//# sourceMappingURL=component.js.map
